import { html } from "lit";
import { getDummyText, getPlaceholderUrl } from "../../../../utils";

export const Template = () => html`
    <ux-iws-nb-content-header>
        <div slot="image">
            <picture>
                <img
                    class="lazyload"
                    alt="Image with 3:2 aspect ratio for mobile and 4:1 for desktop"
                    src="${getPlaceholderUrl(1920, 480)}"
                    data-src="mock-assets/images/trumpf-outdoor.jpg"
                />
            </picture>
        </div>
        <h1 slot="headline">${getDummyText(46)}</h1>
        <p slot="text">${getDummyText(300)}</p>
    </ux-iws-nb-content-header>
`;
